import { EmergencyContactPropertiesDto } from '@/api/generated';

export type EmergencyContactsDetailsTranslation = {
  header: {
    button: {
      edit: string;
    };
  };
  main: {
    fields: Record<keyof EmergencyContactPropertiesDto, string>;
  };
};

export const emergencyContactsDetailsTranslation: EmergencyContactsDetailsTranslation = {
  header: {
    button: {
      edit: 'Edytuj',
    },
  },
  main: {
    fields: {
      category: 'Kategoria',
      createdAt: 'Data utworzenia',
      description: 'Opis',
      email: 'Email',
      name: 'Nazwa',
      phoneNumber: 'Numer telefonu',
      status: 'Status',
    },
  },
};
